<div class="expression-editor">
    <div class="container" [ngClass]="{'algorithm': !!algorithmMode}"
         (click)="onClickContainer($event)">
        <span *ngIf="!disabled" #content contenteditable="true" class="content" [ngClass]="{'algorithm': !!algorithmMode}"
              [innerHTML]="contentHtml"
              (input)="onContentInput($event)">
        </span>
        <span *ngIf="disabled" #content contenteditable="false" class="content" [ngClass]="{'algorithm': !!algorithmMode}"
              [innerHTML]="contentHtml"
              (input)="onContentInput($event)">
        </span>
        <div *ngIf="!content || !content.trim().length" class="hologram">
            <app-icon name="fab-python" class="logo"></app-icon>
        </div>
    </div>
</div>
